<template>
  <div class="linear-progress__wrap">
    <div class="linear-progress">
      <div
        class="progress-line"
        :style="{ height: `${stroke}px`, transform: `scaleX(${progress})` }"
      ></div>
    </div>
    <div class="progress" :style="{ marginTop: `${stroke + 12}px`}">
      <span class="current">{{current}}</span>
      /{{max}}
    </div>
  </div>
</template>
<script>
export default {
  name: "LinearProgress",
  props: {
    stroke: {
      type: Number,
      default: 7
    },
    max: {
      type: Number,
      default: 100
    },
    current: {
      type: Number,
      default: 0
    }
  },
  computed: {
    progress: function() {
      return this.current / this.max;
    }
  }
};
</script>
<style lang="scss" scoped>
.progress-line {
  transition: transform 0.75s;
  transform: scaleX(0);
  transform-origin: 0 0;
  background-color: $color-perform;
  box-shadow: 0 0 5px $color-perform;
  border-radius: 0 30px 30px 0;
}

.linear-progress {
  width: 100%;
  position: absolute;
  top: 0;
  background: $color-white;
}

.linear-progress__wrap {
  width: 100%;
  color: $color-primary;
  .progress {
    display: block;
    width: 100%;
    text-align: center;
  }
  .current {
    font-family: "Open Sans";
  }
}
</style>